/* tslint:disable */
/* eslint-disable */
/**
 * TOM YARD SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export const ContainerHeight = {
  Standard: 'Standard',
  High: 'High',
  Low: 'Low',
} as const

export type ContainerHeight = (typeof ContainerHeight)[keyof typeof ContainerHeight]
